import React from "react";
import ButtonBlack from "@shared/uiNew/Button/button_black";
import * as styles from "./Hero.module.scss";

import { heroData, REGISTER_URL } from "@shared/arrays/sales";

export function Hero() {
  return (
    <section className={styles.hero}>
      <div className={styles.inner}>
        <div className={styles.content}>
          {/* Design-system rule: emphasis in a heading is italic Fraunces via
              <em>, never a coloured block behind the word. */}
          {/* H1 carries the page's primary keyword from content-map.md
              ("sales engagement platform"); the body copy below is the
              original wording. */}
          <h1 className={styles.title}>
            Sales engagement platform that puts your team on the{" "}
            <em>hottest leads</em>
          </h1>
          <p className={styles.subtitle}>{heroData.subtitle}</p>
          <div className={styles.actions}>
            <ButtonBlack
              icon="arrow"
              text={heroData.cta}
              href={REGISTER_URL}
              type="link"
            />
          </div>
        </div>

        <div className={styles.media}>
          <img
            src={heroData.image}
            alt={heroData.imageAlt}
            width={720}
            height={540}
            loading="eager"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
}

export default Hero;
